import { cn } from '@/lib/utils';

const ContactsUnfilled = ({ className = '', ...props }: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    version="1.1"
    viewBox="1 1 14 15"
    aria-hidden="true"
    className={cn('w-5 h-5 fill-none stroke-primary/80 stroke-[1.3px]', className)}
    {...props}
  >
    <path
      d="M10.0003 13.0841L11.3336 14.0841L13.3336 10.7508M10.0003 9.80949C9.40067 9.55691 8.72879 9.41746 8.00026 9.41746C5.73949 9.41746 4.02425 10.7604 3.32191 12.6594C3.04938 13.3963 3.67914 14.0841 4.46482 14.0841H7.33359M10.3336 5.08413C10.3336 6.37279 9.28892 7.41746 8.00026 7.41746C6.71159 7.41746 5.66692 6.37279 5.66692 5.08413C5.66692 3.79546 6.71159 2.75079 8.00026 2.75079C9.28892 2.75079 10.3336 3.79546 10.3336 5.08413Z"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ContactsFilled = ({ className = '', ...props }: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    version="1.1"
    viewBox="1 1 14 15"
    aria-hidden="true"
    className={cn('w-5 h-5 fill-primary stroke-none', className)}
    {...props}
  >
    <path d="M8 2.08413C6.34315 2.08413 5 3.42728 5 5.08413C5 6.74098 6.34315 8.08413 8 8.08413C9.65685 8.08413 11 6.74098 11 5.08413C11 3.42728 9.65685 2.08413 8 2.08413Z" />
    <path d="M8.40012 11.8841C8.13175 12.242 8.00142 12.6605 8.00001 13.0758V13.0894C8.00206 13.6951 8.27819 14.2927 8.80012 14.6841L8.88898 14.7508H3.73231C2.97554 14.7508 2.27077 14.0747 2.46395 13.2151C2.52233 12.9553 2.59666 12.7021 2.68612 12.4566C2.68945 12.4471 2.69288 12.4376 2.69639 12.4281C3.00992 11.5804 3.50457 10.8287 4.14575 10.2294C5.12643 9.31221 6.45117 8.7508 8.00003 8.7508C9.36832 8.7508 10.5617 9.18894 11.4975 9.92345L10.7208 11.218C9.90629 10.9029 8.9499 11.1511 8.40012 11.8841Z" />
    <path d="M13.905 11.0938C14.0945 10.7781 13.9921 10.3686 13.6764 10.1791C13.3606 9.9897 12.9511 10.0921 12.7617 10.4078L11.142 13.1073L10.4 12.5508C10.1055 12.3299 9.68762 12.3896 9.46671 12.6841C9.24579 12.9787 9.30549 13.3965 9.60004 13.6175L10.9334 14.6175C11.0844 14.7307 11.2763 14.7746 11.4615 14.7384C11.6468 14.7021 11.8079 14.589 11.905 14.4271L13.905 11.0938Z" />
  </svg>
);

const ContactUnknownAvatar = ({ className = '', ...props }: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    version="1.1"
    viewBox="0 0 40 40"
    aria-hidden="true"
    className={cn('w-5 h-5', className)}
    {...props}
  >
    <path d="M13.332 16.059C13.332 20.3124 16.2956 23.5063 20.1035 23.5369C23.9116 23.5676 26.8752 20.3124 26.8752 16.059C26.8752 12.0667 23.881 8.75 20.1035 8.75C16.3263 8.75 13.3013 12.0667 13.332 16.059Z" />
    <path d="M7.5 32.1999C10.5096 35.4091 15.1161 37.436 19.9068 37.436C24.6824 37.436 29.3042 35.4091 32.3138 32.1999C30.1334 28.7449 25.3118 26.6875 19.9068 26.6875C14.4558 26.6875 9.64971 28.7758 7.5 32.1999Z" />
  </svg>
);

const ContactPlus = ({ className = 'w-5 h-5', ...props }: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    version="1.1"
    viewBox="0 0 12 12"
    aria-hidden="true"
    className={className}
    {...props}
  >
    <path d="M2.75 3.25C2.75 2.00736 3.75736 1 5 1C6.24264 1 7.25 2.00736 7.25 3.25C7.25 4.49264 6.24264 5.5 5 5.5C3.75736 5.5 2.75 4.49264 2.75 3.25Z" />
    <path d="M1.02229 8.758C1.6177 7.14811 3.08406 6 5.00001 6C6.91596 6 8.38232 7.14811 8.97773 8.758C9.14794 9.21824 9.0314 9.6719 8.76082 9.99437C8.49714 10.3086 8.09009 10.5 7.65159 10.5H2.34843C1.90993 10.5 1.50288 10.3086 1.23919 9.99437C0.968615 9.6719 0.852077 9.21824 1.02229 8.758Z" />
    <path d="M10 4C10 3.72386 9.77614 3.5 9.5 3.5C9.22386 3.5 9 3.72386 9 4V5H8C7.72386 5 7.5 5.22386 7.5 5.5C7.5 5.77614 7.72386 6 8 6H9V7C9 7.27614 9.22386 7.5 9.5 7.5C9.77614 7.5 10 7.27614 10 7V6H11C11.2761 6 11.5 5.77614 11.5 5.5C11.5 5.22386 11.2761 5 11 5H10V4Z" />
  </svg>
);

export { ContactsFilled, ContactsUnfilled, ContactUnknownAvatar, ContactPlus };
